/**
 * @file inference文档页页面路由
 * @author Wanzhongyun
 */

import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Inference1 from './Inference';
import Inference from 'src/components/document/Document';

const DocRoute = () => {
    return (
        <Router>
            <Switch>
                <Route path="/inference/v3.0" component={Inference} />
                <Route path="/inference/master" component={Inference} />
                <Route path="/inference/v2.4" component={Inference} />
                <Route path="/inference/v2.5" component={Inference} />
                <Route path="/inference/v2.6" component={Inference} />
                <Route path="/inference" component={Inference1} />
            </Switch>
        </Router>
    );
};

export default DocRoute;
